import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Removed TypeScript interfaces

export const fetchAnnouncements = createAsyncThunk(
  'announcement/fetchAnnouncements',
  async () => {
    const response = await api.get('/announcement');
    return response.data.data.announcements;
  }
);

export const fetchAnnouncementById = createAsyncThunk(
  'announcement/fetchAnnouncementById',
  async (id) => {
    const response = await api.get(`/announcement/${id}`);
    return response.data.data;
  }
);

export const createAnnouncement = createAsyncThunk(
  'announcement/createAnnouncement',
  async (announcementData) => {
    const response = await api.post('/announcement', announcementData);
    return response.data.data;
  }
);

export const updateAnnouncement = createAsyncThunk(
  'announcement/updateAnnouncement',
  async ({ id, announcementData }) => {
    const response = await api.put(`/announcement/${id}`, announcementData);
    return response.data.data;
  }
);

export const publishAnnouncement = createAsyncThunk(
  'announcement/publishAnnouncement',
  async (id) => {
    const response = await api.post(`/announcement/${id}/publish`);
    return response.data.data;
  }
);

export const deleteAnnouncement = createAsyncThunk(
  'announcement/deleteAnnouncement',
  async (id) => {
    await api.delete(`/announcement/${id}`);
    return id;
  }
);

const initialState = {
  announcements: [],
  currentAnnouncement: null,
  status: 'idle',
  error: null,
};

const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    clearCurrentAnnouncement(state) {
      state.currentAnnouncement = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnnouncements.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAnnouncements.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.announcements = action.payload;
      })
      .addCase(fetchAnnouncements.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(fetchAnnouncementById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAnnouncementById.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.currentAnnouncement = action.payload;
      })
      .addCase(fetchAnnouncementById.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(createAnnouncement.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createAnnouncement.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.announcements.push(action.payload);
      })
      .addCase(createAnnouncement.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(updateAnnouncement.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateAnnouncement.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.announcements.findIndex(a => a.id === action.payload.id);
        if (index !== -1) {
          state.announcements[index] = action.payload;
        }
      })
      .addCase(updateAnnouncement.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(publishAnnouncement.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(publishAnnouncement.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const index = state.announcements.findIndex(a => a.id === action.payload.id);
        if (index !== -1) {
          state.announcements[index] = action.payload;
        }
      })
      .addCase(publishAnnouncement.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      })
      .addCase(deleteAnnouncement.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteAnnouncement.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.announcements = state.announcements.filter(a => a.id !== action.payload);
      })
      .addCase(deleteAnnouncement.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? null;
      });
  },
});

export const { clearCurrentAnnouncement } = announcementSlice.actions;

export default announcementSlice.reducer;